<template>
  <div class="case-news-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-section">
      <div class="breadcrumb">
        <span class="breadcrumb-item link" @click="goBack">造价师服务</span>
        <span class="breadcrumb-separator">></span>
        <span class="breadcrumb-item link" @click="goBack">造价师详情</span>
      </div>
    </div>

    <!-- 个人简介信息 -->
    <div class="profile-section">
      <div class="profile-header">
        <div class="avatar-section">
          <img :src="$getImageUrl(engineerInfo.avatar)" alt="用户头像" class="user-avatar">
          <div class="user-info">
            <h2 class="username">{{ engineerInfo.name || '加载中...' }}
              <span v-if="engineerInfo.online_status === 1" class="online-badge">
                <i class="online-dot" />
                {{ engineerInfo.online_text || '在线' }}
              </span>
            </h2>
            <div class="certifications">
              <div v-if="engineerInfo.certification_status === 1" class="cert-item cost-engineer">
                <img src="@/assets/image/al/zjs.png" alt="造价师" class="cert-icon">
                <span>{{ engineerInfo.certification_text || '造价师认证' }}</span>
                <span v-if="engineerInfo.enterprise_certification === 1" style="margin-left: 20px;">{{ engineerInfo.enterprise_text || '企业认证' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="profile-details">
        <div style="display: flex; gap: 20px;">
          <div class="detail-item">
            <span class="label">服务单数：</span>
            <span class="value">{{ engineerInfo.consultation_count || 0 }}</span>
          </div>
          <div class="detail-item">
            <span class="label">咨询次数：</span>
            <span class="value">{{ engineerInfo.consultation_count || 0 }}</span>
          </div>
        </div>
        <div class="detail-item">
          <span class="label">专业：</span>
          <span class="value">{{ engineerInfo.specialty || '未设置' }}</span>
        </div>
        <div class="detail-item">
          <span class="label">从业时间：</span>
          <span class="value">{{ engineerInfo.work_start_time_text || '未设置' }}</span>
        </div>
        <div class="detail-item">
          <span class="label">职称：</span>
          <span class="value">{{ engineerInfo.title || '未设置' }}</span>
        </div>
        <div class="detail-item">
          <span class="label">星级评价：</span>
          <div class="star-rating">
            <img
              v-for="n in 5"
              :key="n"
              :src="n <= Math.floor(parseFloat(engineerInfo.rating || 0)) ? require('@/assets/image/scy.png') : require('@/assets/image/scn.png')"
              alt="星"
              class="star-icon"
            >
            <span style="margin-left: 8px; color: #666;">{{ engineerInfo.rating_text || '0.0分' }}</span>
          </div>
        </div>
      </div>

      <div class="profile-intro">
        <p><span style="color: #999999;">个人简介：</span>{{ engineerInfo.introduction || '暂无个人简介' }}</p>
      </div>
    </div>

    <!-- 我的案例 -->
    <div class="my-cases-section">
      <h3 class="section-title">我的案例</h3>
      <div v-if="loading" class="loading-text">加载中...</div>
      <div v-else-if="myCases.length === 0" class="no-data">暂无案例</div>
      <div v-else class="cases-grid">
        <div
          v-for="caseItem in myCases"
          :key="caseItem.id"
          class="case-card"
          @click="viewCaseDetail(caseItem)"
        >
          <div class="case-image">
            <img
              :src="$getImageUrl(caseItem.cover_image)"
              :alt="caseItem.title"
              class="case-img"
            >
          </div>
          <div class="case-title">{{ caseItem.title }}</div>
        </div>
      </div>
    </div>

    <!-- 立即咨询按钮 -->
    <div class="consult-section">
      <button class="consult-btn" @click="goConsult">立即咨询</button>
    </div>
  </div>
</template>

<script>
import { getEngineerDetail } from '@/api/user'

export default {
  name: 'CaseNews',
  data() {
    return {
      engineerInfo: {},
      myCases: [],
      loading: false
    }
  },
  created() {
    this.fetchEngineerDetail()
  },
  methods: {
    async fetchEngineerDetail() {
      try {
        this.loading = true
        const engineerId = this.$route.query.id
        if (!engineerId) {
          this.$message && this.$message.error('缺少造价师ID参数')
          return
        }

        const response = await getEngineerDetail(engineerId)
        if (response && response.code === 1 && response.data) {
          this.engineerInfo = response.data
          this.myCases = response.data.cases || []
        }
      } catch (error) {
        console.error('获取造价师详情失败:', error)
        this.$message && this.$message.error('获取造价师详情失败')
      } finally {
        this.loading = false
      }
    },
    viewCaseDetail(caseItem) {
      this.$router.push({
        path: '/costcases/caseDetail',
        query: { id: caseItem.id }
      })
    },
    goConsult() {
      // 检查登录状态
      const { checkAuth } = require('@/utils/auth')
      if (!checkAuth(this.$router, '请先登录后再进行咨询')) {
        return
      }
      this.$router.push({
        path: '/consulting/index',
        query: { cost_engineer_id: this.$route.query.id }
      })
    },
    goBack() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.case-news-container {
	width: var(--page-container-ratio, 70%);
	margin: 0 auto;
  min-height: 100vh;
  background: #f5f5f5;
  padding: 20px;
}

.breadcrumb-section {
  background: #fff;
  padding: 20px 30px;
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .breadcrumb {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666;

    .breadcrumb-item {
      color: #000;
      &.link { cursor: pointer; color: #0F70E2; }
    }

    .breadcrumb-separator {
      margin: 0 8px;
      color: #999;
    }
  }
}

.profile-section {
  background: #fff;
  padding: 30px;
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .profile-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 30px;

    .avatar-section {

      .user-avatar {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        margin-bottom: 20px;
        object-fit: cover;
      }

      .user-info {
        .username {
          font-size: 24px;
          font-weight: bold;
          color: #333;
          margin: 0 0 15px 0;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .online-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 4px 10px;
          background: rgba(0, 203, 19, 0.1);
          border-radius: 16px;
          font-size: 14px;
          color: #00A50F;
          font-weight: 600;
        }

        .online-dot {
          width: 10px;
          height: 10px;
          background: #21b15a;
          border-radius: 50%;
          display: inline-block;
        }

        .certifications {

          .cert-item {
            display: flex;
            align-items: center;
            font-size: 14px;

            .cert-icon {
              width: 16px;
              height: 16px;
              margin-right: 5px;
              object-fit: contain;
            }

            &.cost-engineer {
              color: #0F70E3;
            }

            &.visitor {
              color: #475C70;
            }
          }
        }
      }
    }

    .rating-section {
      .stars {
        display: flex;
        gap: 2px;

        i {
          font-size: 20px;
          color: #ffc107;

          &.el-icon-star-off {
            color: #ddd;
          }
        }
      }
    }
  }

  .profile-details {
    margin-bottom: 30px;

    .detail-item {
      display: flex;
      margin-bottom: 15px;
      font-size: 16px;
      align-items: center;

      .label {
        font-weight: bold;
        color: #999;
        width: 100px;
      }

      .value {
        color: #111111;
      }

      .star-rating {
        display: flex;
        align-items: center;
        gap: 3px;

        .star-icon {
          width: 16px;
          height: 16px;
          object-fit: contain;
        }
      }
    }
  }

  .profile-intro {
    p {
      font-size: 16px;
      line-height: 1.6;
      color: #666;
      text-align: justify;
    }
  }
}

.my-cases-section {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .section-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
  }

  .cases-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;

    .case-card {
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
      }

      .case-image {
        margin-bottom: 10px;
        width: 100%;
        aspect-ratio: 1;
        overflow: hidden;
        border-radius: 6px;

        .case-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 6px;
        }
      }

      .case-title {
        font-size: 14px;
        color: #666;
        line-height: 1.4;
        text-align: center;
      }
    }
  }
}

.consult-section {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.consult-btn {
  width: 100%;
  height: 60px;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  background: linear-gradient(90deg, #0F6FE2, #0C89F2);
}

.loading-text, .no-data {
  text-align: center;
  color: #999;
  padding: 40px;
  font-size: 14px;
}

// 响应式设计
@media (max-width: 1200px) {
  .my-cases-section .cases-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .case-news-container {
    padding: 10px;
  }

  .profile-section,
  .my-cases-section {
    padding: 20px;
  }

  .profile-header {
    flex-direction: column;
    align-items: flex-start;

    .rating-section {
      margin-top: 20px;
    }
  }

  .my-cases-section .cases-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
}

@media (max-width: 480px) {
  .my-cases-section .cases-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }
}
</style>
